/* eslint no-undef: 0 */
module.exports = {
  getCourses: function (params) {
    const options = {
      params: params,
    }

    // Workaround for legacy API
    options.baseURL = `${window.location.origin}/_api`

    return this.client.get('/courses.json/', options)
  },
}
